<template>
  <v-container class="page-content px-5" style="  width: 100%">
    <v-toolbar
        class="rounded-t-lg"
        color="#DADADA"
        flat
    >
      <v-text-field
          ref="search"
          dense
          single-line
          outlined
          v-model="search1"
          label="Поиск"
          hide-details
          @keydown.f1.prevent="searchOrders(false)"
          @keydown="searchOrders()"
      >
      </v-text-field>
      <v-spacer></v-spacer>
      <v-select
          v-model="pagination.filters.order_type"
          label="Тип пропуска"
          class="pt-7"
          outlined
          dense
          style="padding-bottom: 2px"
          single-line
          flat
          :items="choices.order_type"
      >
      </v-select>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="items"
        :expanded.sync="expanded"
        single-expand
        show-expand
        :loading="isLoading"
        :server-items-length="items.length"
        hide-default-footer
        class="elevation-1 rounded-b-lg"
        :item-class="getActiveItemClass"
    >
      <template v-slot:item.through_number="props">
        <span>{{props.item.through_number}}</span>
      </template>
      <template v-slot:item.information="{ item }">
        <span v-if="item.visitor && (item.order_type===SINGLE_ORDER_TYPE || item.order_type===PERMANENT_ORDER_TYPE)">
          {{ item.visitor.fio }}
        </span>
        <span v-else-if="(item.order_type===AUTOMOBILE_SINGLE_ORDER_TYPE || item.order_type===AUTOMOBILE_PERMANENT_ORDER_TYPE)  && item.visitor===null">
          {{item.car.model}} {{item.car.number}}
        </span>
        <span v-else-if="(item.order_type===AUTOMOBILE_SINGLE_ORDER_TYPE || item.order_type===AUTOMOBILE_PERMANENT_ORDER_TYPE)  && item.visitor!==null">
          {{item.car.model}} {{item.car.number}}<br>
          {{ item.visitor.fio }}
        </span>
        <span v-else-if="item.order_type===MASS_ORDER_TYPE"> {{ MASS_ORDER_TYPE }} </span>
<!--        <span v-else-if="item.order_type===VALUES_ORDER_TYPE"> {{ VALUES_ORDER_TYPE }} </span>-->
      </template>
      <template v-slot:item.is_foreigner="props">
        <v-icon v-if="props.item.visitor && props.item.visitor.is_foreigner" color="teal">public</v-icon>
      </template>
      <template v-slot:item.designer="props">
        <span v-if="!!props.item.main_designer">{{ props.item.main_designer.fio }}</span>
        <span v-else>{{ props.item.designer.fio }}</span>
      </template>
      <template v-slot:item.data-table-expand="{ item, select, expand, isExpanded, isSelected }">
<!--        {{isSelected}}-->
        <v-btn v-if="item.order_type===MASS_ORDER_TYPE" icon @click="expand(!isExpanded)" :ref="`expand_button_${item.id}`">
          <v-icon v-if="isExpanded">
            expand_less
          </v-icon>
          <v-icon v-else>
            expand_more
          </v-icon>
        </v-btn>

        <v-btn
          v-else-if="item.visitor || item.car" icon
          @click="checkCarVisitor(item.id, item)"
          :ref="`enter_button_${item.id}`"
        >
          <v-icon v-if="item.visitor && !item.visitor.in_building && item.visitor.last_enter === null" color="blue">
            login
          </v-icon>
          <v-icon v-else-if="item.car && !item.car.in_building && item.car.last_enter === null" color="blue">
            login
          </v-icon>
          <v-icon v-else-if="item.visitor && item.visitor.in_building" color="green">
            login
          </v-icon>
          <v-icon v-else-if="item.car && item.car.in_building" color="green">
            login
          </v-icon>
          <v-icon v-else>
            logout
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="props">
        <td :colspan="props.headers.length" class="mx-0 pa-1">
          <v-card dense tile class="py-0">
            <v-subheader style="color: #065aad; font-size: 1.2rem">Список посетителей</v-subheader>
            <v-data-table
                :headers="headers_visitors"
                :items="itemsVisitors"
                :loading="isLoadingVisitors"
                :server-items-length="itemsVisitors.length"
                hide-default-footer
                class="elevation-1"
                :item-class="getActiveItemClass"
            >
              <template v-slot:item.FIO="props">
                <span>{{props.item.last_name}} {{props.item.first_name}} {{props.item.middle_name}}</span>
              </template>
              <template v-slot:item.is_foreigner="props1">
                <v-icon v-if="props1.item.is_foreigner" color="teal">public</v-icon>
              </template>
              <template v-slot:item.in_out="props">
                <v-btn
                    icon
                    @click="changeMassVisitorPosition(order_id, props.item, props.item.in_building, true)"
                >
                  <v-icon v-if="!props.item.in_building && props.item.last_enter === null" color="blue">
                    login
                  </v-icon>
                  <v-icon v-else-if="props.item.in_building" color="green">
                    login
                  </v-icon>
                  <v-icon v-else>
                    logout
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="updateData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import names from "@/modules/guard/routers/names";
import names_core from "@/modules/core/routers/names"
import guard from "@/urls/roles/guard";

const KEY_NAVIGATION = {
  NEXT: 40,
  PREV: 38,
  OPEN: 32,
  ENTER: 120,
  IN: 39,
  OUT: 37,
  FIND: 112,
  ALL_ORDERS: 113,
  SINGLE_ORDERS: 114,
  PERMANENT_ORDERS: 115,
  MASS_ORDERS: 116,
  AUTOMOBILE_SINGLE_ORDERS: 117,
  AUTOMOBILE_PERMANENT_ORDERS: 118,
  // VALUE_ORDERS: 118,
  END_FOCUS: 27,
  RELOAD: 17
};

const SINGLE_ORDER_TYPE = "Разовый";
const PERMANENT_ORDER_TYPE = "Временный";
const MASS_ORDER_TYPE = "Массовый";
const AUTOMOBILE_SINGLE_ORDER_TYPE = "Автомобильный разовый";
const AUTOMOBILE_PERMANENT_ORDER_TYPE = "Автомобильный временный";
// const VALUES_ORDER_TYPE = "На ценности";

export default {
  name: "GuardOrdersList",
  components: {},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список пропусков",
      selected: {
        index: null,
        object: 0,
        count: null,
        expand: {
          loaded: false,
          is_in: false,
          object: null,
          index: null,
          count: null
        }
      },
      order_id: null,
      expanded:[],
      search1: null,
      timeout: null,
      is_on_focus: false,
      reload_interval: undefined,
      reload_interval_time: 300000,
      set_reload_interval: false,
      key_pressed: false,
      pagination: {
        filters: {
          "search" : null,
          "order_type": null
        }
      },
      choices: {
        order_type: []
      },
      headers: [
        {text: "Номер", value: "through_number", sortable: false, align: "start" , width: "10%"},
        // {text: 'Тип заявки', value: 'order_type', sortable: false, align: 'start' , width: '13%'},
        {text: "Информация", value: "information", sortable: false, align: "start", width: "45%"},
        {text: "Иностранец", value: "is_foreigner", sortable: false, align: "center", width: "5%"},
        // {text: 'Дата начала', value: 'start_date', sortable: true, align: 'center', width: '10%'},
        // {text: 'Дата окончания', value: 'end_date', sortable: true, align: 'center', width: '10%'},
        {text: "Заявитель", value: "designer", sortable: false, align: "start", width: "35%"},
        // {text: 'Территория', value: 'territory.name', sortable: false, align: 'center', width: '15%'},
        // {text: 'Помещение', value: 'room', sortable: false, align: 'center', width: '10%'},
        {text: "", value: "data-table-expand", sortable: false, width: "5%"}
      ],
      headers_visitors: [
        {text: "ФИО", value: "FIO", sortable: false, align: "start"},
        {text: "Организация", value: "organization", sortable: false, align: "start"},
        {text: "Иностранец", value: "is_foreigner", sortable: false, align: "center"},
        {text: "", value: "in_out", sortable: false, align: "center"}
      ]
    }
  },
  watch: {
    expanded: function (newVal) {
      newVal.forEach(el => {
        if (el.visitors === undefined && el.id !== undefined) {
          this.loadVisitors(undefined, el.id);
        }
      });
      if(newVal.length === 0){
        this.selected.expand.loaded = false;
      }
    }
  },
  computed:{
    ...mapGetters({
      items: "guard/getOrdersList",
      count: "guard/getOrdersCount",
      isLoading: "guard/isLoadingOrders",

      itemsVisitors: "guard/getVisitorsList",
      countVisitors: "guard/getVisitorsCount",
      isLoadingVisitors: "guard/isLoadingVisitors",
      isSupLoad: "guard/getSupLoad"
    }),
    SINGLE_ORDER_TYPE: () => SINGLE_ORDER_TYPE,
    PERMANENT_ORDER_TYPE: () => PERMANENT_ORDER_TYPE,
    MASS_ORDER_TYPE: () => MASS_ORDER_TYPE,
    AUTOMOBILE_SINGLE_ORDER_TYPE: () => AUTOMOBILE_SINGLE_ORDER_TYPE,
    AUTOMOBILE_PERMANENT_ORDER_TYPE: () => AUTOMOBILE_PERMANENT_ORDER_TYPE
    // VALUES_ORDER_TYPE: () => VALUES_ORDER_TYPE,
  },
  methods: {
    ...mapActions({
      loadOrdersList: "guard/loadOrdersList",
      loadVisitorsList: "guard/loadVisitorsList",
      letInVisitors: "guard/letInVisitors",
      letOutVisitors: "guard/letOutVisitors",
      loadOrderTypeChoices: "choices/loadOrderTypeChoices",
      setLoad: "guard/setLoad"
    }),
    getActiveItemClass(item){
        return {
          "active": item.id === (this.selected.expand.is_in ? this.selected.expand.object.id : this.selected.object.id),
          "activeUnique": item.id === (this.selected.expand.is_in ? this.selected.expand.object.id : this.selected.object.id)
        }
    },
    updateData(){
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      if (this.search.value) {
        this.search.value = ""
      }
      this.pagination.filters = {
        "order_type": null
      }
      this.loadData()
    },
    getDetail(item) {
      this.$router.push({name: names.ORDERS.DETAIL, params: {idOrders: item.id}}).catch(() => {})
    },
    setCurrentObjectIndex(index) {
      if (this.items.length !== 0) {
        if (index !== undefined && index !== null) {
          if (index >= this.items.length) {
            index = this.items.length - 1
          } else if (index < 0) {
            index = 0
          }
        } else {
          index = 0
        }
        this.selected.object = this.items[index];
        this.selected.index = index;
        this.selected.count = this.items.length;
      }
    },
    loadData(url=undefined, clearIndex = true){
      if (this.set_reload_interval) {
        this.reload_interval = setInterval(() => {
          this.loadOrdersList({
            url: url,
            urlAppend: (url) => {
              return this.addFiltersParameter(url)
            },
            finalizer: (data, url) => {
              this.setCurrentLoadUrl(url);
              this.setCurrentObjectIndex(this.selected.index);
            },
            catcher: (data, url, status) => {
              if (status === 403) {
                this.set_reload_interval = false
                clearInterval(this.reload_interval)
                this.$router.push({name: names_core.MAIN}).catch(() => {})
              }
            }
          })
        }, this.reload_interval_time)
      } else {
        this.loadOrdersList({
          url: url,
          urlAppend: (url) => {
            return this.addFiltersParameter(url)
          },
          finalizer: (data, url) => {
            this.setCurrentLoadUrl(url);
            this.setCurrentObjectIndex(!clearIndex ? this.selected.index : 0);
            this.set_reload_interval = true;
            this.loadData()
          },
          catcher: (data, url, status) => {
            if (status === 403) {
              this.set_reload_interval = false
              clearInterval(this.reload_interval)
              this.$router.push({name: names_core.MAIN}).catch(() => {})
            }
          }
        })
      }
    },
    loadChoices() {
      this.loadOrderTypeChoices({
        url: undefined,
        finalizer: (val) => {
          this.choices.order_type.push({text:"Все",value: null})
          val.forEach(el => {
            this.choices.order_type.push(el)
          })
        }
      })
    },
    loadVisitors(url=undefined, order_id){
      this.selected.expand.loaded = false;
      this.loadVisitorsList({
        url: url,
        order_id: order_id,
        finalizer: (data) => {
          this.order_id = order_id
          this.selected.expand.index = this.selected.expand.index ? this.selected.expand.index : 0;
          this.selected.expand.object = data[this.selected.expand.index ? this.selected.expand.index : 0];
          this.selected.expand.count = data.length;
          this.selected.expand.loaded = true;
        }
      })
    },
    searchOrders(timeout=true){
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      if(this.timeout !== null)
        clearTimeout(this.timeout);
      if (timeout) {
        this.timeout = setTimeout(
            () => {
              this.pagination.filters.search = this.search1
            },
            800
        )
      }else{
        this.pagination.filters.search = this.search1
      }
    },
    scrollToSelectedRow(){
      this.$el.querySelector(".activeUnique").scrollIntoView({block: "center", behavior: "smooth", inline: "center"});
    },
    checkCarVisitor(id, item){
      let data = {}
      if(item.car && item.visitor){
        data.visitor = item.visitor.id
        data.auto = item.car.id
        this.changeVisitorPosition(id, data, item.car.in_building)
      }
      else if (item.car){
        data.auto = item.car.id
        this.changeVisitorPosition(id, data, item.car.in_building)
      }
      else if (item.visitor){
        data.visitor = item.visitor.id
        this.changeVisitorPosition(id, data, item.visitor.in_building)
      }
    },
    changeMassVisitorPosition(id, item, in_building, is_in){
      let data = {}
      data.visitor = item.visitor_id
      this.changeVisitorPosition(id, data, in_building, is_in)
    },
    changeVisitorPosition(id, data, in_building, is_in=false){
      if(in_building){
        this.letOutVisitors({
          data: data,
          id: id,
          finalizer:() =>{
            if(!is_in) {
              this.set_reload_interval = false
              clearInterval(this.reload_interval)
              this.loadData(undefined, false)
            }
            else
              this.loadVisitors(undefined, id)
          }
        })
      }
      else{
        this.letInVisitors({
          data: data,
          id: id,
          finalizer:() =>{
            if(!is_in) {
              this.set_reload_interval = false
              clearInterval(this.reload_interval)
              this.loadData(undefined, false)
            }
            else
              this.loadVisitors(undefined, id)
          }
        })
      }
    },
    prevItem(event) {
      event.preventDefault();
      if (!this.selected.expand.is_in) {
        this.selected.index = this.selected.index > 0 ? this.selected.index - 1 : 0;
        this.selected.object = this.items[this.selected.index];
      } else {
        this.selected.expand.index = this.selected.expand.index > 0 ? this.selected.expand.index - 1 : 0;
        this.selected.expand.object = this.itemsVisitors[this.selected.expand.index];
      }
      this.scrollToSelectedRow();
    },
    nextItem(event) {
      event.preventDefault();
      if (!this.selected.expand.is_in) {
        this.selected.index = this.selected.index < this.selected.count - 1 ? this.selected.index + 1 : this.selected.count - 1;
        this.selected.object = this.items[this.selected.index];
      } else {
        this.selected.expand.index = this.selected.expand.index < this.selected.expand.count - 1 ? this.selected.expand.index + 1 : this.selected.expand.count - 1;
        this.selected.expand.object = this.itemsVisitors[this.selected.expand.index];
      }
      this.scrollToSelectedRow();
    },
    openExpand(event) {
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      if(!this.is_on_focus){
        event.preventDefault();
        if (this.selected.object.order_type === MASS_ORDER_TYPE && !this.selected.expand.is_in) {
          this.$refs[`expand_button_${this.selected.object.id}`].click(event);
        }
      }
    },
    inExpand() {
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      if (this.selected.object.order_type === MASS_ORDER_TYPE && this.selected.expand.loaded) {
        this.selected.expand.is_in = true;
        this.scrollToSelectedRow();
      }
    },
    outExpand() {
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      if (this.selected.object.order_type === MASS_ORDER_TYPE) {
        this.selected.expand.is_in = false;

        this.scrollToSelectedRow();
      }
    },
    focusFind() {
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      this.is_on_focus = true
      event.preventDefault();
      this.$refs["search"].focus();
    },
    endFocus() {
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      this.is_on_focus = false
      event.preventDefault();
      this.$refs["search"].blur();
      this.search1 = null
    },
    filterAllOrders(){
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      event.preventDefault();
      this.pagination.filters.order_type = null
    },
    filterSingleOrders(){
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      event.preventDefault();
      this.pagination.filters.order_type = 1
    },
    filterPermanentOrders(){
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      event.preventDefault();
      this.pagination.filters.order_type = 2
    },
    filterMassOrders(){
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      event.preventDefault();
      this.pagination.filters.order_type = 3
    },
    filterAutomobileSingleOrders(){
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      event.preventDefault();
      this.pagination.filters.order_type = 4
    },
    filterAutomobilePermanentOrders(){
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      event.preventDefault();
      this.pagination.filters.order_type = 5
    },
    // filterValueOrders(){
    //   event.preventDefault();
    //   this.pagination.filters.order_type = 5
    // },
    changeVisitor(){
      this.set_reload_interval = false
      clearInterval(this.reload_interval)
      if (this.selected.object.order_type !== MASS_ORDER_TYPE) {
        this.checkCarVisitor(
            this.selected.object.id,
            this.selected.object
        )
      }
      else if(this.selected.object.order_type === MASS_ORDER_TYPE && this.selected.expand.is_in){
        this.changeMassVisitorPosition(
            this.selected.object.id,
            this.itemsVisitors[this.selected.expand.index],
            this.itemsVisitors[this.selected.expand.index].in_building,
            this.selected.expand.is_in
        )
      }
    },
    // fixEnter(event) {
    //   event.preventDefault();
    //   if (this.selected.object.order_type !== MASS_ORDER_TYPE)
    //     this.$refs[`enter_button_${this.selected.object.id}`].click(event);
    // },
    checkAllowedKeys(keyCode) {
      return (keyCode >= 65 && keyCode <= 90) ||
          (keyCode >= 48 && keyCode <= 57) ||
          [8, 186, 188, 189, 190, 192, 59, 222, 221, 219].indexOf(keyCode) !== -1;
    }
  },
  beforeDestroy() {
    window.onmouseover = undefined
    window.onkeyup = undefined
    window.onkeydown = undefined
  },
  created() {
    if(guard.GUARD.ALLOWED() || window.$cookies.get("guard_hash")){
      this.loadChoices()
      this.loadData()
      let app = this;
      window.onmouseover = (event) => {
        if (document.hasFocus())
          window.focus();
      }
      window.onkeyup = (event) => {
        this.key_pressed = false
        event.preventDefault();
      }
      window.onkeydown = (event) => {
        if (!this.isLoading && !this.isSupLoad && !this.key_pressed) {
          this.key_pressed = true
          switch (event.keyCode) {
            case KEY_NAVIGATION.NEXT:
              this.nextItem(event);
              break;
            case KEY_NAVIGATION.PREV:
              this.prevItem(event);
              break;
            case KEY_NAVIGATION.OPEN:
              this.openExpand(event);
              break;
            case KEY_NAVIGATION.IN:
              this.inExpand();
              break;
            case KEY_NAVIGATION.OUT:
              this.outExpand();
              break;
            case KEY_NAVIGATION.FIND:
              this.focusFind();
              break;
            case KEY_NAVIGATION.END_FOCUS:
              this.endFocus();
              break;
            case KEY_NAVIGATION.ENTER:
                if (!(this.selected.object.order_type === MASS_ORDER_TYPE && !this.selected.expand.is_in)) {
                  this.changeVisitor()
                }
              break;
            case KEY_NAVIGATION.ALL_ORDERS:
              this.filterAllOrders()
              break;
            case KEY_NAVIGATION.SINGLE_ORDERS:
              this.filterSingleOrders()
              break;
            case KEY_NAVIGATION.PERMANENT_ORDERS:
              this.filterPermanentOrders()
              break;
            case KEY_NAVIGATION.MASS_ORDERS:
              this.filterMassOrders()
              break;
            case KEY_NAVIGATION.AUTOMOBILE_SINGLE_ORDERS:
              this.filterAutomobileSingleOrders()
              break;
            case KEY_NAVIGATION.AUTOMOBILE_PERMANENT_ORDERS:
              this.filterAutomobilePermanentOrders()
              break;
            case KEY_NAVIGATION.RELOAD:
              this.set_reload_interval = false
              clearInterval(this.reload_interval)
              this.loadData()
              break;
              // case KEY_NAVIGATION.VALUE_ORDERS:
              //   this.filterValueOrders()
              //   break
            default:
              if(!this.checkAllowedKeys(event.keyCode)){
                event.preventDefault();
              }
              break;
          }
        } else {
          if(!this.checkAllowedKeys(event.keyCode)){
            event.preventDefault();
          }
        }
      }
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }

}

</script>

<style>
.activeUnique {
  background: rgba(33, 150, 243, 0.15) !important;
}
</style>
